import { render } from "./Claim3_For.vue?vue&type=template&id=3c423f88&scoped=true"
import script from "./Claim3_For.vue?vue&type=script&lang=js"
export * from "./Claim3_For.vue?vue&type=script&lang=js"

import "./Claim3_For.vue?vue&type=style&index=0&id=3c423f88&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3c423f88"

export default script